import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import type { Coaching } from '@efdigital/ll-addon-data/types/coaching/coaching';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord } from '@warp-drive/utilities/json-api';

export function findCoaching(id: string) {
  return findRecord<Coaching>(
    DataTypeCoaching.Coaching,
    id,
    jsonApiOptions as FindRecordOptions
  );
}
